import React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const QTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        background: 'rgba(55, 57, 67, 0.95)',
        backdropFilter: 'blur(12px)',
        borderRadius: '10px',
        padding: '8px 12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25), 0 1px 4px rgba(0, 0, 0, 0.15)',
        opacity: 0.97,
        fontSize: '14px',
        fontFamily: 'Assistant, sans-serif',
        color: '#FFFFFF',
        maxWidth: 'none',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'rgba(55, 57, 67, 0.95)',
        '&::before': {
            border: '1px solid rgba(255, 255, 255, 0.1)',
        },
    },
}));

export default QTooltip;